import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { Field } from './Field';
import { FieldContainerProps } from './types';

export const FieldContainer: React.FC<FieldContainerProps> = props => {
  const { children, invalidFields, name, onValidate, ...otherProps } = props;

  const isMobile = useDeviceType() === 'phone';
  const errorMessage = React.useMemo(() => invalidFields?.[name] ?? undefined, [invalidFields, name]);

  const handleBlur = React.useCallback(() => {
    onValidate(name);
  }, [name, onValidate]);

  return (
    <Field {...otherProps} isMobile={isMobile} errorMessage={errorMessage} onBlur={handleBlur}>
      {children}
    </Field>
  );
};
